export const formatValuesToServerData = (values) => ({
  slug: values.slug
})
